export default __webpack_public_path__ + "static/media/telehealth.c204dd3d.png";